<div
  [class.is-small]="isSmall"
  [class.rt-card-clickable]="!shortMessage && activityLocal.event !== 'member_add'"
  [class.activity]="true"
  [class.event]="true"
  [class.unread]="activityLocal.unread"
  [class.candidate-stage-change]="activityLocal.event === 'candidate_stage_change'"
  [class.candidate-review]="activityLocal.event === 'candidate_review'"
  [class.candidate-overdue]="
    activityLocal.event === 'candidate_overdue' ||
    activityLocal.event === 'job_overdue_candidates' ||
    activityLocal.event === 'candidate_gone_overdue'
  "
  [class.task-due]="activityLocal.event === 'task_due_today'"
  [class.icon-red]="
    activityLocal.event === 'task_overdue' ||
    activityLocal.event === 'candidate_disqualify' ||
    activityLocal.event === 'candidate_auto_disqualify' ||
    activityLocal.event === 'job_auto_publish_fail' ||
    activityLocal.event === 'job_auto_close_fail'
  "
  [class.no-padding]="hasNoPadding"
  (click)="onItemClick($event)"
  class="rt-card"
  padding
>
  <div
    class="avatar-icon"
    [attr.margin-right-medium]="hasSmallAvatar ? null : ''"
    [attr.margin-right-small-x]="hasSmallAvatar ? '' : null"
  >
    <rt-avatar
      [rtTooltip]="
        activityLocal.triggered ? ('app.automated_actions.automated_actions' | translate) : null
      "
      [type]="avatarType"
      [size]="hasSmallAvatar ? 'small-x' : 'base'"
      [shape]="'oval'"
      [imageSrc]="avatarUrl"
      [iconName]="avatarIcon!"
      [initials]="activityLocal.initials"
      [fullName]="activityLocal.admin?.name"
      [avatarTpl]="triggerdAvatarTemplate"
      (imageError)="handleAvatarError()"
      [context]="
        avatarType === 'icon' ? 'other' : !!activityLocal.admin?.id ? 'admin' : 'candidate'
      "
    >
    </rt-avatar>
    <div class="icon-wrapper" [class.small]="hasSmallAvatar">
      <rt-icon [name]="icon" [size]="hasSmallAvatar ? 'small-xx' : 'small'"> </rt-icon>
    </div>
  </div>

  <ng-template #triggerdAvatarTemplate>
    @if (activityLocal.triggered) {
      <rt-avatar
        [type]="'icon'"
        [size]="hasSmallAvatar ? 'small-x' : 'base'"
        [shape]="'oval'"
        context="other"
        iconName="automated-actions"
      ></rt-avatar>
    }
    @if (!activityLocal.triggered) {
      <rt-avatar
        [type]="'icon'"
        [size]="hasSmallAvatar ? 'small-x' : 'base'"
        [shape]="'oval'"
        iconName="person"
        context="admin"
      ></rt-avatar>
    }
  </ng-template>

  <div class="content">
    <div class="content__main">
      <!-- SECURITY: These html values are safely sanitized by our backend -->
      <div [innerHTML]="message | rtRemoveHTMLTags: true | emojiFallbackHtml" class="message"></div>
    </div>
    @if (hasDiff) {
      <rt-activity-profile-field-updated
        [previousField]="activityLocal.previousField!"
        [currentField]="activityLocal.field!"
      ></rt-activity-profile-field-updated>
    }
    @if (hasContent() && displayContent) {
      <div class="content__additional">
        <!-- SECURITY: let's leave it for now -->
        @if (
          activityLocal.note &&
          activityLocal.note.bodyHtml &&
          (activityLocal.event === 'candidate_note_add' ||
            activityLocal.event === 'job_note_add' ||
            activityLocal.event === 'share_note_add' ||
            activityLocal.event === 'note_mention')
        ) {
          <div
            [innerHTML]="activityLocal.note.bodyHtml | rtRemoveHTMLTags: true"
            class="quote"
          ></div>
        }
        <!-- SECURITY: mail messages are deprecated, let's ignore this even if it's dangerous -->
        @if (
          activityLocal.message &&
          activityLocal.message.bodyHtml &&
          (activityLocal.event === 'candidate_mail_incoming' ||
            activityLocal.event === 'candidate_mail_outgoing')
        ) {
          <div
            [innerHTML]="activityLocal.message.bodyHtml | rtRemoveHTMLTags: true"
            class="quote"
          ></div>
        }
        @if (
          activityLocal.gdprRequest &&
          activityLocal.gdprRequest.message &&
          activityLocal.event === 'gdpr_request_add'
        ) {
          <div
            [innerHTML]="activityLocal.gdprRequest.message | rtRemoveHTMLTags: true"
            class="quote"
          ></div>
        }
        @if (activityLocal.mailboxMessage && activityLocal.mailboxMessage.text) {
          <div class="quote">
            <div class="mailbox-message">{{ activityLocal.mailboxMessage.text }}</div>
          </div>
        }
        @if (activityLocal.textingMessage && activityLocal.textingMessage.text) {
          <div class="quote">
            <div class="mailbox-message">{{ activityLocal.textingMessage.text }}</div>
          </div>
        }
        <div class="attachment-wrapper">
          @if (activityLocal.attachment) {
            <rt-attachment-item
              [attachment]="$any(activityLocal.attachment)"
              (click)="$event.stopPropagation()"
              type="tile"
            >
            </rt-attachment-item>
          }
        </div>
      </div>
    }
  </div>

  <div (click)="$event.preventDefault()" class="controls" layout layout-align-items-center>
    @if (withTime) {
      <rt-date
        [tiny]="true"
        [time]="activityLocal.createdAt"
        [class.is-not-triggered]="!activityLocal.triggered"
        variant="small"
        text-weight-default
      >
      </rt-date>
    }
    <input
      [id]="activityLocal.id"
      class="read-unread-control"
      type="checkbox"
      [checked]="!activityLocal.unread"
    />
    <label
      (click)="onMarkAsReadClick($event)"
      [for]="activityLocal.id"
      padding-small-x
      margin-left-small
      [rtTooltipPosition]="'left'"
      [rtTooltipShowDelay]="500"
      [rtTooltip]="
        (activityLocal.unread
          ? 'app.notifications.tooltip_mark_read'
          : 'app.notifications.tooltip_mark_unread'
        ) | translate
      "
    >
    </label>
  </div>
</div>
